/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Partnersqralt2Inputs */

const en_partnersqralt2 = /** @type {(inputs: Partnersqralt2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`QR code for ${i?.name}`)
};

const de_partnersqralt2 = /** @type {(inputs: Partnersqralt2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`QR-Code für ${i?.name}`)
};

/**
* | output |
* | --- |
* | "QR code for {name}" |
*
* @param {Partnersqralt2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const partnersqralt2 = /** @type {((inputs: Partnersqralt2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partnersqralt2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_partnersqralt2(inputs)
	return de_partnersqralt2(inputs)
});
export { partnersqralt2 as "partnersQrAlt" }